module.exports = __webpack_public_path__ + "img/new_index_cases16.477988ba.png";